import { Box, Divider, Grid, makeStyles, Typography } from '@freighthub/silhouette-core'
import { FC } from 'react'

type TransportPlanTimeLineContentProps = {
  label: string
  value: string
}

export type TransportPlanItemDescriptionProps = {
  timestamp?: TransportPlanTimeLineContentProps
  description: TransportPlanTimeLineContentProps
}

const useStyles = makeStyles((theme) => ({
  tpDescription: {
    padding: theme.spacing(2),
    height: '100%',
  },
  timestampRoot: {
    textAlign: 'right',
    borderRight: `1px solid ${theme.palette.divider}`,
  },
}))

export const TransportPlanItemDescription: FC<TransportPlanItemDescriptionProps> = ({ timestamp, description }) => {
  const classes = useStyles()

  return (
    <Grid container className={classes.tpDescription} alignItems="center">
      <Grid xs>
        {timestamp ? (
          <Box component="dl" px={2} className={classes.timestampRoot}>
            <Typography component="dt" variant="caption" color="textSecondary">
              {timestamp.label}
            </Typography>
            <Typography component="dd">{timestamp.value}</Typography>
            <Divider orientation="vertical" />
          </Box>
        ) : null}
      </Grid>
      <Grid xs>
        <Box component="dl" px={2}>
          <Typography component="dt" variant="caption" color="textSecondary">
            {description.label}
          </Typography>
          <Typography component="dd">{description.value}</Typography>
        </Box>
      </Grid>
    </Grid>
  )
}
